import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const EllipsisIcon = React.forwardRef((props, ref) => (_jsxs(Svg, { "data-testid": "EllipsisIcon", ...props, ref: ref, fill: props.fill, children: [_jsx("circle", { cx: "3", cy: "8", r: "1.5" }), _jsx("circle", { cx: "8", cy: "8", r: "1.5" }), _jsx("circle", { cx: "13", cy: "8", r: "1.5" })] })));
EllipsisIcon.displayName = "EllipsisIcon";
EllipsisIcon.defaultProps = {
    fill: "currentColor"
};
